<template>
    <div class="flex-page">
        <a-form class="ctrl" layout="inline">

            <a-form-item label="城员">
                <a-input style="min-width: 200px" v-model="search.chengyuanName" placeholder="请输入城员姓名"></a-input>
            </a-form-item>

            <a-form-item label="时间">
                <a-date-picker  v-model="search.start_time" />
                    <span style="margin: 0 20px;">~</span>
                <a-date-picker  v-model="search.end_time" />

            </a-form-item>

            <a-form-item>
                <a-button type="primary" @click="doSearch">搜索</a-button>
            </a-form-item>
        </a-form>

        <div class="article-page">
            <div class="list">
                <div class="statistics">共{{ amount }}条</div>
                <a-table bordered :dataSource="list" :columns="columns" :pagination="false" size="small"
                    :rowKey="(record) => record.id">
                </a-table>
                <a-pagination @change="onChange" :total="amount" :defaultPageSize="50" :defaultCurrent="search.now_page"
                    showQuickJumper class="margin15" />
            </div>
        </div>



    </div>
</template>
  
<style lang='scss' scoped>
</style>
  
<script>
import moment from 'moment'
import QRCode from "qrcode"

export default {
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            columns: [
                {
                    title: "参加城员",
                    dataIndex: "chengyuan_name",
                },
                {
                    title: "贡献值",
                    dataIndex: "gongxianzhi",
                },
                {
                    title: "签到时间",
                    dataIndex: "created_at",
                },
                // {
                //     title: "操作",
                //     dataIndex: "caozuo",
                //     scopedSlots: {
                //         customRender: "caozuo",
                //     },
                // },
            ],
            amount: 0,
            pages: 1,
            list: [],
            search: {
                now_page: 1,
                chengyaunName: '',
                id: '',
                start_time: null,
                end_time: null
            },
        };
    },
    watch: {

    },
    async created() {
        this.search.id = this.$route.query.id;
        this.getList();
    },
    mounted() {
    },
    methods: {
        moment,
        doSearch() {
            this.search.now_page = 1;
            this.getList();
        },
        async getList() {
            const search = JSON.parse(JSON.stringify(this.search))
            if(search.start_time) {
                search.start_time = moment(search.start_time).format("YYYY-MM-DD")
            }
            if(search.end_time) {
                search.end_time = moment(search.end_time).format("YYYY-MM-DD")
            }
            const r = await this.$axios.get("/shellCity/getChengyuanJoinList", { params: search });
            this.list = r.list;
            this.amount = r.amount;
        },
        onChange(e) {
            this.search.now_page = e;
            this.getList();
        }
    },
};
</script>
  
<style>
</style>
